import React from 'react'

import './HouseImage.css'

export const HouseImage = () => {
  return (
    <div className='house-image__container'>
      <img
        src={
          window.hdpPageProps.houseData.exterior_images[0][
            'max-1600x1200.watermarked'
          ]
        }
        alt={window.hdpPageProps.houseData.exterior_images[0]['alt_text']}
        className='house-image__img'
      />
    </div>
  )
}
